import { RoleDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/role`;

export const getAllRoles = (source: CancelTokenSource): Promise<Array<RoleDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchRole = (query: String, source: CancelTokenSource): Promise<Array<RoleDto>> => {
  return axios
      .get(`${apiUri}`, {params: {query}, cancelToken: source.token})
      .then(response => response.data);
};

export const findRoleById = (roleId: string, source: CancelTokenSource): Promise<RoleDto> => {
  return axios
      .get(`${apiUri}`, {params: {roleId}, cancelToken: source.token})
      .then( response => response.data)
};

export const addRole = (roleDto: Partial<RoleDto>, source: CancelTokenSource): Promise<RoleDto> => {
  return axios
      .post(apiUri, roleDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editRole = (roleId: string, roleDto: Partial<RoleDto>,
                               source: CancelTokenSource): Promise<RoleDto> => {
  return axios
      .put(`${apiUri}`, roleDto, {params: {roleId}, cancelToken: source.token})
      .then(response => response.data);
};

export const deleteRole = (roleId: string, source: CancelTokenSource): Promise<String> => {
  return axios
      .delete(`${apiUri}`, {params: {roleId}, cancelToken: source.token})
      .then(response => response.data);
};


